// Add debounce utility function at the top
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        slider: this.querySelector('[id^="Slider-Gallery-"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      // if (!this.elements.thumbnails) return;

      // this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      if (this.dataset.desktopLayout === 'stacked') {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
      } else {
        this.initSlider();
      }

      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    initSlider() {
      const mainSlider = document.querySelector(this.mainSliderSelector);
      
      // Now debounce will be defined when used
      const debouncedResize = debounce(() => {
        if (this.slider) this.slider.resize();
      }, 250);
      
      let config = JSON.parse(this.elements.slider.getAttribute('data-flickity-config'));
      this.flckty = this.flckty || new Flickity(this.elements.slider, config);

      this.flckty.on('change', debounce(this.onSlideChanged.bind(this), 500));

      // Debug thumbnails
      if (!this.elements.thumbnails) {
        return;
      }
      
      let thumbsSlider = this.elements.thumbnails.querySelector('[data-flickity-config]');
      
      let thumbsConfig = JSON.parse(thumbsSlider.getAttribute('data-flickity-config'));
      
      // Add custom pagination
      thumbsConfig.pageDots = false; // Disable default Flickity dots
      this.thumbsFlckty = this.thumbsFlckty || new Flickity(thumbsSlider, thumbsConfig);
      
      // Create custom dots container
      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'thumbnail-dots';
      
      // Calculate number of dots needed (4 thumbnails per page)
      const totalImages = this.thumbsFlckty.slides.length;
      const dotsNeeded = Math.ceil(totalImages / 4);
      
      // Create dots
      for (let i = 0; i < dotsNeeded; i++) {
        const dot = document.createElement('button');
        dot.className = 'thumbnail-dot';
        dot.setAttribute('aria-label', `Page ${i + 1}`);
        if (i === 0) dot.classList.add('is-selected');
        
        // Add click handler
        dot.addEventListener('click', () => {
          this.thumbsFlckty.select(i * 4);
        });
        
        dotsContainer.appendChild(dot);
      }
      
      // Insert dots after thumbnails
      this.elements.thumbnails.appendChild(dotsContainer);
      
      // Update dots on slide change
      this.thumbsFlckty.on('change', (index) => {
        const currentPage = Math.floor(index / 4);
        const dots = dotsContainer.querySelectorAll('.thumbnail-dot');
        
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-selected', i === currentPage);
        });
      });
    }

    onSlideChanged(index) {
      const activeMediaId = this.elements.slider.querySelectorAll(('.flickity-slider [id^="Slide-"]'))[index].dataset.mediaId;
      this.setActiveMedia(activeMediaId, false);
      const thumbnail = this.elements.thumbnails.querySelectorAll('[id^="Slide-Thumbnails-"]')[index];
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      // this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
      //   element.classList.remove('is-active');
      // });
      // activeMedia.classList.add('is-active');

      if (prepend) {
        if (this.dataset.desktopLayout === 'stacked') {
          activeMedia.parentElement.prepend(activeMedia);
        } else {
          this.flckty.slider.prepend(activeMedia);
        }

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (this.dataset.desktopLayout === 'stacked') {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          } else {
            this.thumbsFlckty.slider.prepend(activeThumbnail);
          }
          if (this.thumbsFlckty) this.reloadSlider(this.thumbsFlckty);
        }
        if (this.flckty) this.reloadSlider(this.flckty);
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        // if (this.elements.thumbnails) {
        //   activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        // }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      this.elements.thumbnails.querySelector('.is-selected button').setAttribute('aria-current', true);
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    reloadSlider(flckty) {
      flckty.reloadCells();
      flckty.reposition();
      flckty.resize();
      if (!flckty.options.asNavFor) {
        setTimeout(() => {
          // var el = flckty.element;
          // var config = flckty.options;
          // flckty.destroy();
          // this.flckty = new Flickity(el, config)
          flckty.select(0);
        }, 100);
      }
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
